import React from 'react'
import  '../Components/MyPortfolioSection.css'
import {Link} from "react-router-dom";
import DesignImages from '../images/Design2.png'
import UxImages from '../images/UX2.png'


const MyPortfolioSection = () => {
  return (
    <div>
          <div className="MyBody">

              <h1 className='MyPortfolioHeading'>My portfolio </h1> 
              
              <div className='MyPortfolioAllBox'>


                <div className='MyPortfolioBox1'> 

                  
                   <img className='MyPortfolioBoxImage' src={UxImages} alt="images of projects"/>
                 
                  
                  <div className='MyPortfolioBoxContent'>
                    <h3 className='MyPortfolioBoxHeading'>UX Case studies</h3>
                    <p className='MyPortfolioContent' >
                    Read my UX case studies and explore prototypes to gain insights 
                    into my design process and approach to problem-solving and user 
                    centered design.
                    </p>                  
                    <Link className='MyPortfolioUXBtn' to = "/casestudies">
                       Read UX Case studies
                    </Link>                    
                  </div>

                </div>


                <div className='MyPortfolioBox2'>

                  <img className='MyPortfolioBoxImage' src={DesignImages} alt="" />


                    <div className='MyPortfolioBoxContent'> 
                        <h3 className='MyPortfolioBoxHeading'>Design</h3>
                          <p className='MyPortfolioContent' >
                              Worked with startups and agencies to develop 
                              brand strategies and create impactful marketing materials for web and print.                          
                          </p> 
                          <Link className='MyPortfolioUXBtn' to = "/design">
                          View Design
                        </Link>
                    </div>
                </div>

                {/* <div className='MyPortfolioBox3'>

                  <img className='MyPortfolioBoxImage' src={DevImages} alt =""/>


                    <div className='MyPortfolioBoxContent'> 
                        <h3 className='MyPortfolioBoxHeading'>&lt;Dev Projects&gt;</h3>
                          <p className='MyPortfolioContent' >
                               Read my UX case studies and explore prototypes to gain insights 
                              into my design process and approach to problem-solving and user 
                              centered design.
                          </p> 
                          <Link className='MyPortfolioUXBtn' to = "/design">
                           View Projects
                        </Link>
                    </div>
                </div> */}

                  
              </div>



        </div>
    </div>
  )
}

export default MyPortfolioSection